<template>
    <v-app>
        <Toolbar title="Transaction Report"/>
        <v-layout row>
            <v-flex xs12 sm12 offset-sm0>
                <v-card>
                    <v-card-title primary-title>
                        <v-btn @click="$router.push({path: '/device/' + groupId + '/' + deviceId})">
                            <v-icon dark>arrow_back</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <div>
                            <div class="headline">{{ deviceId }}</div>
                            <span class="grey--text">Group: {{ groupName }}</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-flex>
        </v-layout>
        <v-container>
            <v-layout row>
                <v-flex xs12 sm5 md4>
                    <v-dialog
                            ref="dialog1"
                            v-model="modal1"
                            :return-value.sync="startDate"
                            persistent
                            lazy
                            full-width
                            width="290px"
                    >
                        <v-text-field
                                slot="activator"
                                v-model="startDate"
                                label="Report Start Date"
                                prepend-icon="event"
                                readonly
                        ></v-text-field>
                        <v-date-picker v-model="startDate" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal1 = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="$refs.dialog1.save(startDate)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-flex>
                <v-flex xs12 sm5 md4>
                    <v-dialog
                            ref="dialog2"
                            v-model="modal2"
                            :return-value.sync="endDate"
                            persistent
                            lazy
                            full-width
                            width="290px"
                    >
                        <v-text-field
                                slot="activator"
                                v-model="endDate"
                                label="Report End Date"
                                prepend-icon="event"
                                readonly
                        ></v-text-field>
                        <v-date-picker v-model="endDate" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="$refs.dialog2.save(endDate)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-flex>
                <v-flex xs12 sm2 md4>
                    <v-btn color="gray" @click="fetchTransactions">Generate Report</v-btn>
                </v-flex>
            </v-layout>

            <v-container>
                <v-toolbar color="dark-grey" dark>
                    <v-toolbar-title>Report</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout row>&nbsp;</v-layout>
                <v-layout row>
                    <v-flex xs4 sm4 md4>
                        <div class="headline"></div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="headline">Count</div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="headline">Amount</div>
                    </v-flex>
                </v-layout>
                <v-layout row>&nbsp;</v-layout>
                <v-layout row>
                    <v-flex xs4 sm4 md4>
                        <div class="title">Sub Total</div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="title">{{ transactions.length }}</div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="title">{{ (subTotal / 100).toFixed(2) }}</div>
                    </v-flex>
                </v-layout>
                <v-layout row>&nbsp;</v-layout>
                <v-layout row>
                    <v-flex xs4 sm4 md4>
                        <div class="title">Tips</div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="title">{{ tipCount }}</div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="title">{{ (tipTotal / 100).toFixed(2) }}</div>
                    </v-flex>
                </v-layout>
                <v-layout row>&nbsp;</v-layout>
                <v-layout row>
                    <v-flex xs4 sm4 md4>
                        <div class="title">Cashback</div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="title">{{ cashbackCount }}</div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="title">{{ (cashbackTotal / 100).toFixed(2) }}</div>
                    </v-flex>
                </v-layout>
                <v-layout row>&nbsp;</v-layout>
                <v-layout row>
                    <v-flex xs4 sm4 md4>
                        <div class="headline">Total</div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="headline">{{ transactions.length }}</div>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                        <div class="headline">{{ (total / 100).toFixed(2) }}</div>
                    </v-flex>
                </v-layout>

            </v-container>


        </v-container>

    </v-app>
</template>

<script>
    import {mapActions} from 'vuex'
    import Toolbar from '../components/Toolbar'

    const fb = require('../firebase')

    export default {
        name: "Report",
        data() {
            return {
                startDate: new Date().toISOString().substr(0, 10),
                endDate: new Date().toISOString().substr(0, 10),
                modal1: false,
                modal2: false,
                subTotal: 0,
                tipTotal: 0,
                tipCount: 0,
                cashbackTotal: 0,
                cashbackCount: 0,
                total: 0,
                transactions: [],
                tipValue: [],
                totalValue: []
            }
        },
        components: {Toolbar},
        mounted() {
            if (fb.auth.currentUser === null || fb.auth.currentUser === undefined || !this.isUserLoggedIn()) {
                this.$router.push({path: '/signin'})
                return
            }

            if (this.deviceId === undefined || this.deviceId === 'undefined') {
                this.$router.push({path: '/groups'})
            }

            this.fetchAll()

            this.fetchTransactions()
        },
        computed: {
            groupId: function () {
                return this.$route.params['group_id']
            },
            groupName: function () {
                let group = this.$store.state.groups[this.groupId]

                if (group !== undefined) {
                    return group.name
                }
                return ''
            },
            deviceId: function () {
                return this.$route.params['device_id']
            }
        },
        methods: {
            ...mapActions(['fetchAll', 'isUserLoggedIn']),
            fetchTransactions: function () {
                this.$store.commit('showProgress')
                fb.transactionsCollection
                    .where('deviceId', '==', 'castles_' + this.deviceId + '@kineticsmart.com')
                    .where('timestamp', '>', new Date(this.startDate))
                    .where('timestamp', '<', new Date(this.endDate))
                    .get()
                    .then((transactions) => {
                        this.$store.commit('hideProgress')

                        if (!transactions.empty) {
                            this.subTotal = 0
                            this.tipTotal = 0
                            this.tipCount = 0
                            this.cashbackTotal = 0
                            this.total = 0
                            this.transactions = []

                            this.totalValue = []

                            this.tipValue = []

                            transactions.forEach((transaction) => {
                                let data = transaction.data()
                                this.subTotal = this.subTotal + parseInt(data.base_amount)
                                this.tipTotal = this.tipTotal + parseInt(data.tip_amount)
                                if (parseInt(data.tip_amount) > 0) {
                                    this.tipCount = this.tipCount + 1
                                }
                                this.cashbackTotal = this.cashbackTotal + parseInt(data.cashback_amount)
                                if (parseInt(data.cashback_amount) > 0) {
                                    this.cashbackCount = this.cashbackCount + 1
                                }
                                this.total = this.total + parseInt(data.total_amount)

                                this.tipValue.push(parseInt(data.tip_amount) / 100)
                                this.totalValue.push(parseInt(data.total_amount) / 100)

                                this.transactions.push({
                                    timestamp: data.timestamp,
                                    baseAmount: this.subTotal,
                                    tipAmount: this.tipTotal,
                                    cashbackAmount: this.cashbackTotal,
                                    totalAmount: this.total
                                })
                            })
                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>
